import React from 'react';

import propTypes from 'prop-types';
import MembershipCartUpsell from './upsells/MembershipCartUpsell';
import CommitmentCartUpsell from './upsells/CommitmentCartUpsell';
import FreeShippingCartUpsell from './upsells/FreeShippingCartUpsell';

export default class UpsellBanner extends React.Component {
  static propTypes = {
    canBecomeMember: propTypes.bool.isRequired,
    hasSubscriptionCommitment: propTypes.bool.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    isSubscribableStore: propTypes.bool.isRequired,
    minimumSubscriptionItems: propTypes.number.isRequired,
    requiredSubscribableItems: propTypes.number.isRequired,
    shippingCost: propTypes.number.isRequired,
    storeCode: propTypes.string.isRequired,
    subscribableQuantity: propTypes.number.isRequired,
  };

  get hasMinimumSubscribableItems() {
    return this.props.requiredSubscribableItems <= 0;
  }

  get hasFreeShipping() {
    return this.props.shippingCost <= 0;
  }

  render() {
    const {
      canBecomeMember,
      evergreenOffering,
      hasSubscriptionCommitment,
      isMembershipOrder,
      isSubscribableStore,
      storeCode,
      subscribableQuantity,
    } = this.props;

    const hasEvergreenOffering = evergreenOffering && evergreenOffering.id;
    const canShowMembershipUpsell =
      (subscribableQuantity > 0 || isMembershipOrder) && isSubscribableStore;

    if (storeCode === 'juul-il') {
      // No upsell banners in Israel
      return null;
    } else if (
      hasSubscriptionCommitment &&
      !this.hasMinimumSubscribableItems &&
      isSubscribableStore
    ) {
      // Display the commitment banner after the user has toggled it on
      // this will communicate to the user what they need to do in order
      // to checkout with the commitment i.e. add 1 more pod pack to your cart
      return (
        <CommitmentCartUpsell
          hasMinimumSubscribableItems={this.hasMinimumSubscribableItems}
          {...this.props}
        />
      );
    } else if (
      canBecomeMember &&
      (hasEvergreenOffering || canShowMembershipUpsell)
    ) {
      // Display the membership banner before a user has toggled the
      // membership toggle to on, this will communicate to the user why they
      // would want to become a member
      return (
        <MembershipCartUpsell
          hasMinimumSubscribableItems={this.hasMinimumSubscribableItems}
          {...this.props}
        />
      );
    }

    return <FreeShippingCartUpsell {...this.props} />;
  }
}
